export default __webpack_public_path__ + "static/media/Stupa-darker-transparent.5765970c.png";